<q9-sidebar
  class="story-sidebar"
  [disableClose]="disableClose"
  [opened]="opened"
  [supportTracks]="false">
  <ng-container *ngIf="!loading(); else loader">
    <ng-container *ngIf="displayTemplate === 'root' && node">
      <div q9-sidebar-title [title]="node.name"></div>

      <ng-template q9-sidebar-tab [title]="'CORE.SIDEBAR.DETAILS_TAB' | translate">
        <q9rme-root-details-tab></q9rme-root-details-tab>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="displayTemplate === 'node' && node">
      <div q9-sidebar-title [title]="node.name || node.customId"></div>
      <q9-sidebar-action>
        <q9-icon-button
          icon="component"
          q9Track="TOOLTIPS.SET_AS_ROOT"
          matTooltipPosition="below"
          [disabled]="disableMakeNodeRoot()"
          matTooltip="{{ 'TOOLTIPS.SET_AS_ROOT' | translate }}"
          (click)="makeNodeRoot()"></q9-icon-button>

        <q9-follow-star [activeItem]="selectedNode()" type="rmn"></q9-follow-star>

        <q9-icon-button
          data-qa="edit-implementation"
          [matTooltip]="'SIDEBAR.DESCRIPTION_EDIT' | translate"
          matTooltipPosition="below"
          (click)="editNode(node)"
          icon="sidebar:edit"></q9-icon-button>

        <q9-icon-button
          [matTooltip]="'SIDEBAR.DELETE_NODE' | translate"
          matTooltipPosition="below"
          icon="sidebar:delete"
          (click)="deleteNode(node)"></q9-icon-button>
      </q9-sidebar-action>

      <ng-template
        q9-sidebar-tab
        [title]="'CORE.SIDEBAR.DETAILS_TAB' | translate"
        [count]="stakeholdersCount()">
        <q9rme-details-tab></q9rme-details-tab>
      </ng-template>

      <ng-template
        q9-sidebar-tab
        [title]="'CORE.SIDEBAR.DOCUMENTATION_TAB' | translate"
        [count]="documentationTabCount()">
        <q9-org-node-documentation-tab></q9-org-node-documentation-tab>
      </ng-template>

      <ng-template
        q9-sidebar-tab
        [title]="'CORE.SIDEBAR.INSIGHT_TAB' | translate"
        [count]="dependenciesTabCount()">
        <q9rme-node-insight-tab></q9rme-node-insight-tab>
      </ng-template>

      <ng-template
        q9-sidebar-tab
        [title]="'CORE.SIDEBAR.CHANGES_TAB' | translate"
        [count]="changesTabCount()">
        <q9rme-changes-tab></q9rme-changes-tab>
      </ng-template>
    </ng-container>
  </ng-container>
</q9-sidebar>

<ng-template #loader>
  <q9-content-loader [isLoading]="loading()"></q9-content-loader>
</ng-template>
